"use strict";

var _slicedToArray = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * A High Order Component (HOC) function that provides
 * the contextual `width` and `height` props to a GL Component.
 * It also merge optional width,height props to override the contextual size
 * @function connectSize
 * @param GLComponent - a React Component that receives width and height props
 * @returns {ReactClass<*>} a Component that merge width and height props
 * with context and renders `GLComponent`.
 * @example
 *  const Foo = ({ width, height }) => <Node uniforms={{ width, height }} />;
 *  const FooConnected = connectSize(Foo);
 *  <FooConnected /> // you don't have to provide width, height.
 *  <FooConnected width={64} height={64} /> // If you do, you override width,height in the context as well, so <Node> is implicitly receiving the new width/height.
 */


var connectSize = function connectSize(GLComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_react$Component) {
    _inherits(_class, _react$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "context", void 0);

      return _this;
    }

    _createClass(_class, [{
      key: "getGLSize",
      value: function getGLSize() {
        var _this$props = this.props,
            width = _this$props.width,
            height = _this$props.height,
            glSizable = this.context.glSizable;
        if (width && height) return [width, height];

        var _glSizable$getGLSize = glSizable.getGLSize(),
            _glSizable$getGLSize2 = _slicedToArray(_glSizable$getGLSize, 2),
            cw = _glSizable$getGLSize2[0],
            ch = _glSizable$getGLSize2[1];

        return [width || cw, height || ch];
      }
    }, {
      key: "getChildContext",
      value: function getChildContext() {
        return {
          glSizable: this
        };
      }
    }, {
      key: "render",
      value: function render() {
        var onConnectSizeComponentRef = this.props.onConnectSizeComponentRef;

        var _this$getGLSize = this.getGLSize(),
            _this$getGLSize2 = _slicedToArray(_this$getGLSize, 2),
            width = _this$getGLSize2[0],
            height = _this$getGLSize2[1];

        return _react.default.createElement(GLComponent, _extends({
          ref: onConnectSizeComponentRef
        }, this.props, {
          width: width,
          height: height
        }));
      }
    }]);

    return _class;
  }(_react.Component), _defineProperty(_class, "displayName", "connectSize(".concat(GLComponent.displayName || GLComponent.name || "?", ")")), _defineProperty(_class, "propTypes", {
    width: _propTypes.default.number,
    height: _propTypes.default.number
  }), _defineProperty(_class, "contextTypes", {
    glSizable: _propTypes.default.object.isRequired
  }), _defineProperty(_class, "childContextTypes", {
    glSizable: _propTypes.default.object.isRequired
  }), _temp;
};

var _default = connectSize;
exports.default = _default;